import {httpRequest} from "../../../utils/HttpRequest";
import {IOrganRemove,IOrganSearch,IOrganUpdate,IOrganInsert,IOrganDetail,IOrganParams,IOrganDisable} from "./organizationTypes"
import {IPage} from "../../../types/FmsTypes";

class OrganService {
    async page(params:IOrganSearch){
        const apiUrl = "/md/org/page"
        return await httpRequest.post<IPage<IOrganDetail>>(apiUrl,params)
    }
    async insert(params:IOrganInsert){
        const apiUrl = "/md/org/insert"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async update(params:IOrganUpdate){
        const apiUrl = "/md/org/update"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async remove(params:IOrganRemove){
        const apiUrl = "/md/org/remove"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async disable(params:IOrganDisable){
        const apiUrl = "/md/org/disable"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
}
const organService = new OrganService()
export {
    organService
}